import alert from "@/plugins/AlertMessages.js";

export default {
  token: null,
  staticCode: null,

  postCheck: false,
  checkAlert: 0,
  successMessage: null,
  warningMessage: null,
  infoMessage: null,
  dangerMessage: null,

  loadingBtn: false,
  loadingCheck: 0,
  loadingMessage: alert.success.loading,
  isMenuActive: false,
  selectedLanguage: localStorage.getItem("PCMSClientLanguage"),
};
